
import { defineComponent } from "vue";
import meetlookup from "../MeetLookup";

export default defineComponent({
  name: "AthletesFavorite",
  mixins: [meetlookup],
  props: {
    athleteid: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      lastNameFirstLetter: "",
      firstName: "",
      namePrefix: "",
      lastNameWithoutFirstLetter: "",
      gender: "1",
    };
  },
  methods: {
    get_last_name_first_letter_from_athlete_id(athlete_id) {
      for (let i = 0; i < this.athletes.length; i++) {
        if (this.athletes[i].id == athlete_id) {
          this.lastNameFirstLetter = this.athletes[i].lastname.charAt(0);
          this.firstName = this.athletes[i].firstname;
          this.namePrefix = this.athletes[i].nameprefix;
          this.lastNameWithoutFirstLetter = this.athletes[i].lastname.substr(
            1,
            this.athletes[i].lastname.length
          );
          this.gender = this.athletes[i].gender;
        }
      }
    },
    updateFavorites() {
      if (!this.is_favorite(this.athleteid)) {
        this.$store.dispatch(
          "addFavorite",
          this.get_base_athlete_from_athlete_id(this.athleteid)
        );
      } else {
        this.$store.dispatch(
          "removeFavorite",
          this.get_base_athlete_from_athlete_id(this.athleteid)
        );
      }
    },
  },
  mounted() {
    this.get_last_name_first_letter_from_athlete_id(this.athleteid);
  },
});
